import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import SectionFields from "../tabs/common/Section/SectionFields";
import { buildSatelliteImageryFields } from "../fields/satelliteImagery";
import { buildLocationPinMapField } from "../fields/locationPinMap";
import type { SatelliteImage } from "../../types";

export function ReadOnlySatelliteImageryContainer({
  satelliteImagery,
  locationPinMapLink,
}: {
  satelliteImagery?: Array<SatelliteImage>;
  locationPinMapLink?: string;
}) {
  const satelliteImageryFields = buildSatelliteImageryFields(satelliteImagery);

  return (
    <Box data-testid="read-only-satellite-imagery-container">
      <SectionCollapsible label="Satellite Imagery">
        <SectionFields
          fields={[
            ...satelliteImageryFields,
            buildLocationPinMapField(
              locationPinMapLink,
              satelliteImageryFields.length,
            ),
          ]}
          columns={2}
          fieldIdPrefix="read-only-satellite-imagery"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlySatelliteImageryContainer;
